import { render, staticRenderFns } from "./CategoryBar.vue?vue&type=template&id=3ea0f402&scoped=true"
import script from "./CategoryBar.vue?vue&type=script&lang=js"
export * from "./CategoryBar.vue?vue&type=script&lang=js"
import style0 from "./CategoryBar.vue?vue&type=style&index=0&id=3ea0f402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0f402",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbar})
